<script>
import moment from 'moment'
import { Bar } from 'vue-chartjs'

export default {
  name: 'InspLoadDimChart',
  extends: Bar,

  components: {},

  props: {
    items: {
      type: Array,
      required: true,
    },
    name: {
      type: String,
      required: false,
      default: '',
    },
    companyName: {
      type: String,
      required: false,
      default: '',
    },
  },

  data() {
    return {
      data: {},
      options: {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: true,
          fontSize: '24',
          text: this.$t('ELE0306'),
        },
        layout: {
          padding: {
            top: 10,
            bottom: 10,
            left: 0,
            right: 0,
          },
        },
        scales: {
          xAxes: [
            {
              display: true,
              ticks: {
                autoSkip: true,
                autoSkipPadding: 0,
                display: true,
                minRotation: 90,
                crossAlign: 'far',
                padding: 5,
              },
              gridLines: {
                drawOnChartArea: false,
                drawTicks: false,
              },
              stacked: true,
            },
          ],
        },
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            //Round Legend Labels
            // usePointStyle: true,
          },
        },
        tooltips: {
          mode: 'nearest',
          intersect: false,
        },
        plugins: {
          datalabels: {
            display: false,
          },
        },
      },
    }
  },
  methods: {
    setItems() {
      let data = {
        datasets: [],
        labels: [],
        tooltips: [],
      }

      let totalReceiveLot = {
        label: this.$t('ELE0296'),
        type: 'line',
        borderColor: '#5840ad',
        pointBackgroundColor: '#5840ad',
        backgroundColor: 'transparent',
        lineTension: 0,
        fill: true,
        data: [],
      }
      let outstandingDim = {
        label: this.$t('ELE0301'),
        type: 'line',
        borderColor: '#8c1429',
        pointBackgroundColor: '#8c1429',
        backgroundColor: 'transparent',
        lineTension: 0,
        fill: true,
        data: [],
      }
      let capaDimNormal = {
        label: this.$t('ELE0108'),
        type: 'line',
        borderColor: '#23BB68',
        pointBackgroundColor: '#23BB68',
        backgroundColor: 'transparent',
        borderDash: [10],
        pointRadius: 0,
        lineTension: 0,
        fill: true,
        data: [],
      }
      let capaDimOt = {
        label: this.$t('ELE0109'),
        type: 'line',
        borderColor: 'red',
        pointBackgroundColor: 'red',
        backgroundColor: 'transparent',
        borderDash: [10],
        pointRadius: 0,
        lineTension: 0,
        fill: true,
        data: [],
      }
      let totalDimLot = {
        label: this.$t('ELE0299'),
        type: 'bar',
        stack: 'Stack',
        backgroundColor: '#70b2ff',
        data: [],
      }
      let esProjectCount = {
        label: this.$t('ELE0297'),
        type: 'bar',
        stack: 'Stack',
        backgroundColor: '#0e7d9c',
        data: [],
      }
      let analyzedQty = {
        label: this.$t('ELE0298'),
        type: 'bar',
        stack: 'Stack',
        backgroundColor: '#984807',
        data: [],
      }
      let sameLot = {
        label: this.$t('ELE0300'),
        type: 'bar',
        stack: 'Stack',
        backgroundColor: '#C6D9F1',
        data: [],
      }

      this.items.forEach((item) => {
        capaDimNormal.data.push(item.capaDimNormal ?? 0)
        capaDimOt.data.push(item.capaDimOt ?? 0)
        totalReceiveLot.data.push(item.totalReceiveLot ?? 0)
        totalDimLot.data.push(item.totalDimLot ?? 0)
        esProjectCount.data.push(item.totalReceiveEsLot ?? 0)
        analyzedQty.data.push(item.analyzedQty ?? 0)
        sameLot.data.push(item.totalSameLot ?? 0)
        outstandingDim.data.push(item.totalReceiveLot - (item.totalDimLot + item.totalSameLot) || 0)
        data.labels.push(moment(item.date).format('Do MMM'))
      })

      data.datasets = [
        capaDimNormal,
        capaDimOt,
        totalReceiveLot,
        outstandingDim,
        totalDimLot,
        esProjectCount,
        analyzedQty,
        sameLot,
      ]

      this.options.title.text = `${this.$t('ELE0306')} F1 ${this.name} ${
        this.companyName ? '( IQC ' + this.companyName + ')' : ''
      }`
      this.data = data
    },
    async displayChart() {
      await this.setItems()
      this.renderChart(this.data, this.options)
    },
  },
  mounted() {
    this.displayChart()
  },
  watch: {
    items: {
      handler: function () {
        this.displayChart()
      },
      deep: true,
    },
  },
}
</script>
